import { motion } from 'framer-motion';
import styled from 'styled-components';

import { accordionTransition, AccordionVariant, accordionVariants } from '@pkg/motion';
import { designColor, styledInteraction, styledTypography } from '@pkg/primitives';

interface StyledFormMessageProps {
    $error?: boolean;
}

export const StyledFormMessage = styled(motion.div).attrs({
    variants: accordionVariants,
    initial: AccordionVariant.Hidden,
    animate: AccordionVariant.Show,
    exit: AccordionVariant.Hidden,
    transition: accordionTransition,
})<StyledFormMessageProps>`
    --form-message-color: ${({ $error }) => ($error ? designColor.redLight : '#4cff00')};

    // Necessary to create a "space after" in place of a
    // gap/margin/padding (required for smooth height animation).
    &::after {
        ${styledInteraction.interactionDisable};
        content: '';
        display: block;
        width: 100%;
        height: 20px;
    }
`;

export const Label = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    color: var(--form-message-color);
`;
